import React, { useState, useEffect } from 'react';
import Navbar from './components/Navbar';
import InfoCountry from './components/InfoCountry';
import Hero from './components/Hero';
import Footer from './components/Footer';
import Product from './components/Product';
import InfoUs from './components/InfoUs';
import WhatsAppButton from './components/WhatsAppButton';
import Blogs from './components/Blogs';

export default function App() {
  const [currentPage, setCurrentPage] = useState('home');
  const [scrollTo, setScrollTo] = useState(null);

  // Escuchar cambios en la URL
  useEffect(() => {
    const handlePopState = () => {
      const path = window.location.pathname;
      if (path === '/blogs') {
        setCurrentPage('blogs');
      } else {
        setCurrentPage('home');
      }
    };
    
    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, []);

  // Scroll después de cambiar de página
  useEffect(() => {
    if (currentPage === 'home' && scrollTo) {
      setTimeout(() => {
        const element = document.getElementById(scrollTo);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
        setScrollTo(null);
      }, 200);
    }
  }, [currentPage, scrollTo]);

  const goToHome = (sectionId = null) => {
    if (sectionId) {
      setScrollTo(sectionId);
    }
    setCurrentPage('home');
    window.history.pushState({}, '', '/');
  };

  const goToBlogs = () => {
    setCurrentPage('blogs');
    window.history.pushState({}, '', '/blogs');
  };

  if (currentPage === 'blogs') {
    return (
      <>
        <Navbar goToHome={goToHome} goToBlogs={goToBlogs} currentPage="blogs" />
        <Blogs goToHome={goToHome} />
        <WhatsAppButton phoneNumber="525662930619" />
      </>
    );
  }

  return (
    <>
      <Navbar goToHome={goToHome} goToBlogs={goToBlogs} currentPage="home" />
      <main>
        <section id="inicio"><Hero /></section>
        <InfoCountry />
        <section id="productos"><Product /></section>
        <section id="nosotros"><InfoUs /></section>
        
      </main>
      <section id="contacto"><Footer /></section>
      <WhatsAppButton phoneNumber="525662930619" />
    </>
  );
}